export interface CommonOptions {
    logVerbosity: number;
    developmentMode: boolean;
}
